import { ReactNode } from "react";
import Select, { components, GroupBase } from "react-select";
import { InputSpecificProps } from "react-select/dist/declarations/src/components/Input";

import styles from "@components/fieldsNative/InputSelect.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import { inputSelectStyles } from "@utils/formUtils";

type Option = {
  image?: ReactNode;
  isFixed: boolean;
  label: string;
  value: string;
};

type Props = {
  noOptionsLabel: string;
  onChange: (values: string[]) => void;
  options: Option[];
  placeholder: string;
  values: string[];
};

const Input = ({ ...props }) => (
  <components.Input {...(props as InputSpecificProps<unknown, boolean, GroupBase<unknown>>)} data-lpignore="true" />
);
const InputSelect = ({ noOptionsLabel, onChange, options, placeholder, values }: Props) => {
  const formatOptionLabel = ({ image, label }: Option) => (
    <div className={styles.label}>
      {image && <div>{image}</div>}
      <div>{label}</div>
    </div>
  );

  return (
    <div>
      <div className={styles.inputWrapper}>
        <Select
          autoFocus={true}
          classNamePrefix="react-select"
          components={{ Input }}
          defaultMenuIsOpen
          formatOptionLabel={formatOptionLabel}
          isMulti
          isSearchable
          menuPortalTarget={document.body}
          noOptionsMessage={() => <BodyCopy color="gray-500">{noOptionsLabel}</BodyCopy>}
          onChange={option => {
            const properlyTypedOption = option as unknown as Option[];
            onChange(properlyTypedOption.map(option => option.value));
          }}
          openMenuOnFocus
          options={options}
          placeholder={placeholder}
          styles={inputSelectStyles}
          value={options.filter(option => values.includes(option.value))}
        />
      </div>
    </div>
  );
};

export default InputSelect;
